import type { ReactNode } from 'react';
import { cn } from './utils';

/**
 * Eyebrow label for a section head or stat-card caption. Always
 * `tracking-widest` — call sites had drifted between `-widest` and
 * `-wider`; normalized here.
 */
export function SectionLabel({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('text-[11px] font-semibold uppercase tracking-widest text-muted-foreground', className)}>
      {children}
    </div>
  );
}
